import React from 'react'
import Img from 'gatsby-image'

const WhyUs = (props) => {
	return (

		<section className="uk-cover-container overlay-wrap">
			<Img
                    sizes={props.foto}
                    style={{
                        top: 0,
                        left: 0,
                        position: 'absolute',
                        objectFit: 'cover',
                        height: '100%',
                        width: '100%'
                    }}
                    imgStyle={{
                        objectPosition: 'center center',
                    }}
                />
			<div className="uk-container uk-position-z-index uk-position-relative uk-section uk-section-xlarge uk-light">
				<div className="uk-grid uk-child-width-1-2@l uk-flex-middle">
					<div>
						<h5>BENVENUTI SU PROWEDDING</h5>
						<h2 className="uk-margin-small-top uk-h1">Il portale dedicato a tutti i futuri sposi</h2>
						<p className="subtitle-text">
							Per il giorno del vostro matrimonio se desiderate un servizio fotografico e video unico, su ProWedding avrete la possibilità di scegliere i migliori fotografi e videomakers professionisti per matrimoni.
						</p>
						<p className="subtitle-text">
							Prowedding offre una serie di funzioni utili all'organizzazione del proprio matrimonio e la ricerca del professionista giusto secondo i vostri gusti
	Visita i profili dei fotografi per scoprire il loro approccio e avere maggiori informazioni su come organizzereranno il servizio fotografico per il tuo matrimonio
</p>

					</div>
					<div data-uk-scrollspy="cls: uk-animation-fade">
						<img src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" data-src="img/marketing-2.svg" data-uk-img alt="Image" />
					</div>
				</div>
			</div>
		</section>


	)
}

export default WhyUs



// WEBPACK FOOTER //
// ./src/components/homepage/whyus/index.js